import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { UserFeedbackService } from '@shared';
import { catchError, throwError } from 'rxjs';

export const UniquErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const messageService = inject(UserFeedbackService);

  return next(req).pipe(
    catchError((error) => {
      if (
        error.error?.errorCode === 'VALIDATION_FAILED' &&
        error.error?.reason === 'UNIQUE_CONSTRAINT'
      ) {
        messageService.error(
          'Greška pri spremanju',
          `Polje "${error.error.field}" s istom vrijednosti postoji!`
        );
      }
      return throwError(() => error);
    })
  );
};
